import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmUpdateBasketDelegator {
	constructor() {
		this.type = GtmTrackingType.UPDATE_BASKET;
		this.preventDefault = true;
		this.preventDefaultSync = true;
		this.dataMapper = [
			{
				useDataValueFrom: 'skuID',
				gtmKey: 'id',
			},
			{
				useDataValueFrom: 'skuName',
				gtmKey: 'name',
			},
			{
				useDataValueFrom: 'skuPriceexVAT',
				gtmKey: 'price',
			},
			{
				useDataValueFrom: 'skuCategory',
				gtmKey: 'category',
			},
			{
				useDataValueFrom: '',
				gtmKey: 'brand',
			},
			{
				useDataValueFrom: '',
				gtmKey: 'variant',
			},
		];
	}

	getTrackingData(target) {
		this.target = target;
		const product = TrackingHelperInstance.getProductRowFromDataLayer(target);
		this.originalValue = product.skuQty;
		this.inputValue = this.processMinMax(target);
		const differential = this.differential();
		const objWithQuantity = Object.assign(
			{},
			TrackingHelperInstance.mapDataViaGtmKey(target, this.dataMapper),
			{
				quantity: `${Math.abs(this.inputValue - this.originalValue)}`,
			},
		);
		const actionType = this.resolveAction(differential);

		return {
			event: actionType === 'add' ? 'addToCart' : 'removeFromCart',
			ecommerce: {
				[actionType]: {
					actionField: {
						list: TrackingHelperInstance.generateActionFieldString(),
					},
					products: [objWithQuantity],
				},
			},
		};
	}

	processMinMax(target) {
		const inputValue = +target
			.closest('.product-row')
			.querySelector('input[name="quantity"]').value;
		const targetStoreElement =
			TrackingHelperInstance.resolveTargetStore(target);

		const dataMin = targetStoreElement.getAttribute('data-min');
		const dataMax = targetStoreElement.getAttribute('data-max');

		const min = dataMin && isNaN(+dataMin) ? undefined : +dataMin;
		const max = dataMax && isNaN(+dataMax) ? undefined : +dataMax;
		let resolvedValue;

		if (min && inputValue < min) {
			resolvedValue = min;
		} else if (max && inputValue > max) {
			resolvedValue = max;
		} else {
			resolvedValue = inputValue;
		}

		return resolvedValue;
	}

	resolveAction(differential) {
		let action;
		switch (differential) {
			case 'positive':
				action = 'add';
				break;
			case 'negative':
				action = 'remove';
				break;
			default:
		}

		return action;
	}

	differential() {
		let differentialValue;

		if (this.inputValue > this.originalValue) {
			differentialValue = 'positive';
		} else if (this.inputValue < this.originalValue) {
			differentialValue = 'negative';
		} else {
			differentialValue = 'neutral';
		}

		return differentialValue;
	}

	preventDefaultSyncCallback() {
		this.target.closest('form').submit();
	}
}

const GtmUpdateBasketDelegatorInstance = new GtmUpdateBasketDelegator();
export default GtmUpdateBasketDelegatorInstance;

// for test purpose only
export const GtmUpdateBasketDelegatorClass = GtmUpdateBasketDelegator;
